import { ApiPaths } from 'api/constants';
import { ProcessGeneral } from 'api/endpoints/processes';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import {
  CreateParams,
  ISearchTemplateRepo,
  SearchTemplateGeneral,
} from './ISearchTemplateRepo';

export class SearchTemplateRepo
  extends BaseRepo
  implements ISearchTemplateRepo
{
  create(
    draft: ProcessGeneral,
    name: string,
    url: URL
  ): ApiResponseAsync<SearchTemplateGeneral> {
    const params: CreateParams = {
      url: url.href,
      name,
      processId: draft.id,
    };

    return this.helpers.handlePost<CreateParams, SearchTemplateGeneral>(
      ApiPaths.searchTemplate._(),
      params
    );
  }

  getAll(opts?: {
    limit?: number;
    offset?: number;
  }): ApiResponseAsync<DataWithTotal<SearchTemplateGeneral>> {
    const link = ApiPaths.searchTemplate._();

    const qs = new URLSearchParams();

    if (opts?.limit !== undefined) qs.set('limit', opts.limit.toString());
    if (opts?.offset !== undefined) qs.set('offset', opts.offset.toString());

    return this.helpers.handleGet(link + (qs.size ? '?' + qs.toString() : ''));
  }

  deleteTemplate(template: SearchTemplateGeneral): ApiResponseAsync<void> {
    const link = ApiPaths.searchTemplate.byId._({
      [ApiUrlParams.searchTemplateId]: template.id,
    });

    return this.helpers.handleDelete(link);
  }
}
